import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/header';
import Header2 from '../../components/header2';
import { FaPhone, FaMapMarkerAlt, FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useMediaQuery } from 'react-responsive';
import './style.css';

export default function ContactPage() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    return (
        <div className="vh-100 vw-100 d-flex flex-column">
            <Header2 />
            <Header />
            <div className='bg-space'></div>
            <Container fluid className="flex-grow-1 d-flex align-items-center justify-content-center bg-color">
                <Row className="w-100 h-100 d-flex align-items-center justify-content-center">
                    {/* Coluna Esquerda - Logo e Mensagem */}
                    <Col md={5} xs={12} className="text-center px-4 mb-4 mb-md-0">
                    <div className='bg-space1'></div>
                        <h2 style={{ fontFamily: 'Georama' }}>
                            Quer saber mais?
                        </h2>
                        <p style={{ fontFamily: 'Georama' }}>Entre em contato.</p>
                        <div className="mt-4 d-flex justify-content-center gap-3">
                            <a href="https://www.facebook.com/RepublicaSemDestino/" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <FaFacebook size={30} className="text-primary" />
                            </a>
                            <a href="https://www.instagram.com/repsemdestino/" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <FaInstagram size={30} className="text-danger" />
                            </a>
                            <a href="https://www.tiktok.com/@repsemdestino" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <FaTiktok size={30} className="text-dark" />
                            </a>
                        </div>
                        <div className="mb-3 text-center">
                            <br></br>
                            <FaMapMarkerAlt className="me-2 text-primary" />
                            <strong>Endereço:</strong> Rua Conselheiro Quintiliano, 210<br></br>Ouro Preto, Minas Gerais<br></br>35.400-000
                        </div>
                        <div className="mb-3 text-center">
                            <FaPhone className="me-2 text-primary" />
                            <strong>Telefone:</strong> <a href="tel:+553133505046" className="text-primary">(31) 3350-5046</a>
                        </div>
                    </Col>

                    {/* Coluna Direita - Mapa, Contato e Redes Sociais */}
                    <Col md={5} xs={12} className="px-4 d-flex flex-column justify-content-center align-items-center">
                        <iframe 
                            title='Mapa da República Sem Destino'
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3739.995843401597!2d-43.50415932501251!3d-20.383061252576063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa40adf82f1802f%3A0xfefc58567e599cc6!2sRep%C3%BAblica%20Sem%20Destino!5e0!3m2!1sen!2sbr!4v1739748370337!5m2!1sen!2sbr" 
                            width={isMobile ? "100%" : "600"}
                            height={isMobile ? "250" : "400"}
                            style={{ borderRadius : 12 }} 
                            allowFullScreen
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                        <div className='bg-space1'></div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
